import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Lock, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { login, admin } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (admin && admin.email) nav("/admin"); }, [admin, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      toast.error(apiErr(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  const cls = "w-full rounded-lg bg-black/50 border border-white/10 px-3 py-3 text-sm outline-none focus:border-[#D4AF37] focus:ring-1 focus:ring-[#D4AF37]";

  return (
    <div className="min-h-screen grid place-items-center bg-[#0A0A0A] grain px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="font-display font-bold tracking-[0.18em] gold-text text-3xl">QWERJOH</div>
          <div className="text-[10px] uppercase tracking-[0.32em] text-white/40 mt-1">Media · Admin</div>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form" className="card-surface rounded-2xl p-8 gold-glow space-y-4">
          <div className="grid place-items-center h-12 w-12 rounded-full bg-[#D4AF37]/10 border border-[#D4AF37]/30 mx-auto"><Lock className="text-[#D4AF37]" size={20} /></div>
          <div>
            <label className="block text-xs uppercase tracking-wider text-white/50 mb-1.5">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" className={cls} />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-wider text-white/50 mb-1.5">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" className={cls} />
          </div>
          <button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="w-full rounded-lg bg-gradient-to-r from-[#D4AF37] to-[#F0D77B] py-3 font-semibold text-[#0A0A0A] flex items-center justify-center gap-2 gold-glow-hover">
            {loading ? <Loader2 className="animate-spin" size={18} /> : "Sign In"}
          </button>
          <div className="text-center"><Link to="/admin/forgot-password" className="text-xs text-white/50 hover:text-[#D4AF37]">Forgot password?</Link></div>
        </form>
        <div className="text-center mt-6"><Link to="/" className="text-xs text-white/40 hover:text-[#D4AF37]">← Back to website</Link></div>
      </div>
    </div>
  );
}
